/* eslint-disable camelcase */
import { Alert, Button, Container, Grid, Stack, Typography, } from '@mui/material';
import Localization from 'l18n/l18n';
import AuthUser from 'models/auth';
import React, { useEffect, useState } from 'react';
import {Helmet} from 'react-helmet';
import { useForm } from 'react-hook-form';
import PasswordChange from './components/password_change';

export default function AccountSettings() {
    const [ errors, setErrors ] = useState([]);
    const [ isLoading, setIsLoading ] = useState(false);
    const [ success, setSuccess ] = useState(false);
    const { handleSubmit, control, reset, watch, } = useForm({ defaultValues: {
            old_password: '',
            new_password: '',
            repeat_new_password: '',
        }, });
    const onSubmit = (data) => {
        if (isLoading) return; 
        setSuccess(false);
        const { new_password, repeat_new_password, old_password } = data;

        if (new_password.length < 6) {
            setErrors([ 'new_password', Localization.translate.weak_password ]);
        } else if (String(new_password) !== String(repeat_new_password)) {
            setErrors([ 'repeat_new_password', Localization.translate.passwords_dont_match ]);
        } else if (old_password.trim().length < 1) {
            setErrors([ 'old_password', Localization.translate.old_password_is_required ]);
        } else {
            setIsLoading(true);
            AuthUser.ChangePassword({ new_password: new_password.trim(),
                old_password: old_password.trim(), }).then((response) => {
                setErrors([]);
                if (response.success) setSuccess(true);
            }).catch((error) => {
                if (error.response.data) {
                    const err = error.response.data;
                    if (err.error === 15 || err.message === 'password_not_match') {
                        setErrors([ 'old_password', Localization.translate.invalid_password ]);
                    } else if (err.message === 'change_password_failed' || err.error === 18 || err.message === 'identical_passwords_error') {
                        setErrors([ 'change_password_failed', Localization.translate.old_password_is_same_as_new_password ]);
                    } else if (err.message === 'weak_password' || err.error === 48) {
                        setErrors([ 'new_password', Localization.translate.weak_password ]);
                    } else {
                        setErrors([ 'error', err.message ]);
                    }
                } else {
                    setErrors([ 'error', Localization.translate.error ]);
                }
            });
            setIsLoading(false);
        }
    };

    useEffect(() => { 
        reset({ 
        old_password: '',
        new_password: '',
        repeat_new_password: ''  }); }, [ success ]);

    useEffect(() => {
        const subscription = watch(() => setErrors([]));
        return () => subscription.unsubscribe();
    }, [ watch ]);

    const successMessage = success ? (<Alert severity="success">{Localization.translate.success_change_password}</Alert>) : '';
    const ErrorMessage = errors[ 0 ] === 'error' ? (<Alert severity="error">{Localization.translate.error}</Alert>) : '';
    return ( 
    <>
    <Helmet>
        <title>{`${Localization.translate['app_name']} | ${Localization.translate['account_settings']}`}</title>
    </Helmet>
    <form>
        <Container maxWidth="lg" sx={ { mt: 4, mb: 4 } }>
            <Grid container spacing={ 2 }>
                <Typography component="h4" variant="h4" color="#000000" sx={ {ml: 2, mt: 2, mb: 2 } }>
                    {Localization.translate.account_settings}
                </Typography>
                <Grid container spacing={ 2 }>
                    <Grid item xs={ 12 }>
                        <Stack>
                            <Typography sx={ { mt: 2, ml: 1, fontWeight: 'bold' } }>
                                {Localization.translate.change_password}
                            </Typography>
                            {successMessage}
                            {ErrorMessage}
                        </Stack>
                    </Grid>

                    <PasswordChange errors={ errors } control={ control } />
                    <Grid spacing={ { xs: 4, md: 0 } } item container sx={ { ml: 2, mt: 10 } }>
                        <Grid item xs={ 12 } md={ 6 }>
                            <Button type="submit" variant="outlined" sx={ { padding: '0.5rem 4rem', boxShadow: 'none', borderRadius: 0 } } onClick={ () => reset() }>
                                {Localization.translate.cancel}
                            </Button>
                        </Grid>
                        <Grid item xs={ 12 } md={ 6 }>
                            <Button  type="submit" variant="contained" onClick={ handleSubmit(onSubmit) }  sx={ {  padding: '0.5rem 4rem', boxShadow: 'none', borderRadius: 0, color: '#FFFFFF',} } >
                                {Localization.translate.save_new_password}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    </form>
    </>
    );
}
